export class Ersteinrichtung {
    vvvo = 0;
    entsorger = 0;
    haendler = 0;
    gruppen = 0;

    constructor(vvvo?: number, entsorger?: number, haendler?: number, gruppen?: number) {
        this.vvvo = vvvo;
        this.entsorger = entsorger;
        this.haendler = haendler;
        this.gruppen = gruppen;
    }
}
